// Module
var code = "<nlg-comments comments=occurrence.comments parent-id=occurrence.id editable=\"!editable || editable()\" save-comment=\"submitComment(occurrence, comment)\" hide-status-change=isStatusFinal(occurrence) url-download-attachments=getUrlDownloadAttachment(comment) monitorable-source-id=monitorableSourceId> </nlg-comments>";
// Exports
module.exports = code;